import { DocumentationContentType } from '@modules/clients/docSiteSearchType';

export interface SearchCategory {
  value: DocumentationContentType;
  translationKey: string;
  fallbackLabel: string;
}

export const DEFAULT_SEARCH_CATEGORY = DocumentationContentType.All;

export const SEARCH_CATEGORIES: readonly SearchCategory[] = [
  {
    value: DocumentationContentType.LuaAPI,
    translationKey: 'Label.EngineAPI',
    fallbackLabel: 'Engine API',
  },
  {
    value: DocumentationContentType.CloudAPI,
    translationKey: 'Label.CloudAPI',
    fallbackLabel: 'Cloud API',
  },
  {
    value: DocumentationContentType.Article,
    translationKey: 'Label.Articles',
    fallbackLabel: 'Articles',
  },
  {
    value: DocumentationContentType.Video,
    translationKey: 'Label.Videos',
    fallbackLabel: 'Videos',
  },
  {
    value: DocumentationContentType.DevForum,
    translationKey: 'Label.DevForum',
    fallbackLabel: 'Forum',
  },
];
